<template>
  <!-- overlay-class="web-view-overlay" -->
  <van-popup
    v-model:show="webViewPopupConfig.isShowPopup"
    position="bottom"
    :class="['web-view-popup', webViewPopupConfig.popupClass]"
    teleport="body"
    @open="isShowIframe = true"
    @closed="closed"
  >
    <div v-if="isShowIframe && h5PageRoute.path" class="iframe-container">
      <iframe
        :id="webViewId"
        :src="h5PageRoute.path"
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="yes"
      ></iframe>
    </div>
  </van-popup>
</template>
<!-- 游戏webView弹窗 -->
<script setup lang="ts">
defineOptions({ name: 'WebViewPopup' })

const webBridgeStore = useWebBridgeStore()
const { webViewId, webViewPopupConfig } = storeToRefs(webBridgeStore)

// 监听路由，切换页面关闭弹窗
const router = useRouter()
router.afterEach(() => {
  closed()
})

/** 内嵌H5信息 */
const h5PageRoute = computed(() => {
  return webBridgeStore.h5PageRoutes[webViewPopupConfig.value.key]
})

watch(
  () => webViewPopupConfig.value.isShowPopup,
  () => {
    if (webViewPopupConfig.value.isShowPopup) {
      // 开启监听
      nextTick(() => {
        webBridgeStore.startMessage()
      })
    }
  },
  {
    immediate: true
  }
)

// 是否关闭 iframe，用这关闭是为了保留 van-popup 关闭的效果，用 closed 回调再关闭
const isShowIframe = ref<boolean>(false)

function closed() {
  // 移除监听
  webBridgeStore.removeMessage()
  isShowIframe.value = false
  webBridgeStore.setWebView({
    type: 2,
    isShowPopup: false,
    popupClass: ''
  })
}
</script>

<style lang="scss" scoped>
.web-view-overlay {
  background: transparent;
}
.web-view-popup {
  right: 0;
  margin: 0 auto;
  width: 375px;
  height: 90%;
  background: transparent;
  @include media-screen(mobile) {
    width: 100%;
  }
  &.fishing-popup {
    height: 375px;
  }
  .iframe-container {
    width: 100%;
    height: 100%;
    overflow: hidden; // 暂时推荐是为了隐藏滚动条
    iframe {
      width: 100%;
      height: 100%;
      background: transparent;
    }
  }
}
</style>
